import Pagination from "react-bootstrap/Pagination";

export default function CustomPagination({
  last,
  selected,
  onPageChange,
  total,
  current,
}) {
  return (
    <div>
      <Pagination>
        <Pagination.First
          onClick={() => onPageChange(1)}
          disabled={selected === 1}
        />
        <Pagination.Prev
          onClick={() => onPageChange(selected - 1)}
          disabled={selected === 1}
        />

        {selected > 1 && (
          <Pagination.Item
            onClick={() => onPageChange(1)}
            active={selected === 1}
          >
            {1}
          </Pagination.Item>
        )}

        {selected > 1 + 2 && <Pagination.Ellipsis disabled />}

        {selected - 2 > 1 && (
          <Pagination.Item onClick={() => onPageChange(selected - 2)}>
            {selected - 2}
          </Pagination.Item>
        )}
        {selected - 1 > 1 && (
          <Pagination.Item onClick={() => onPageChange(selected - 1)}>
            {selected - 1}
          </Pagination.Item>
        )}

        <Pagination.Item active>{selected}</Pagination.Item>

        {selected + 1 < last && (
          <Pagination.Item onClick={() => onPageChange(selected + 1)}>
            {selected + 1}
          </Pagination.Item>
        )}
        {selected + 2 < last && (
          <Pagination.Item onClick={() => onPageChange(selected + 2)}>
            {selected + 2}
          </Pagination.Item>
        )}

        {selected < last - 2 && <Pagination.Ellipsis disabled />}

        {selected < last && (
          <Pagination.Item
            onClick={() => onPageChange(last)}
            active={selected === last}
          >
            {last}
          </Pagination.Item>
        )}

        <Pagination.Next
          onClick={() => onPageChange(selected + 1)}
          disabled={selected === last}
        />
        <Pagination.Last
          onClick={() => onPageChange(last)}
          disabled={selected === last}
        />
      </Pagination>
      Current Instances Displayed: {current} <br /> Total Instances: {total}
    </div>
  );
}
